jQuery(document).ready(function ($) {
    jQuery(document).ready(function ($) {
        // Delegate event to parent element (body or a specific container)
        jQuery('body').on('click', '.mj-directory-listing__item .add_to_wishlist', function (e) {
            e.preventDefault();

            const postId = $(this).data('id');
            const userId = $(this).data('login');
            const postType = $(this).data('type');
            var postTypeText = "";
            let wishlistCookie = null;

            if (postType == "venue") {
                postTypeText = "Venue";
                wishlistCookie = getCookie('wishlist_pending_venues');
            } else if (postType == "supplier") {
                postTypeText = "Supplier";
                wishlistCookie = getCookie('wishlist_pending_suppliers');
            }

            var isInWishlist = wishlistCookie ? JSON.parse(wishlistCookie).includes(postId) : false;
            // Check if user is not logged in
            if (userId === 0) {
                if (!wishlistCookie || (wishlistCookie && !isInWishlist)) {
                    addToWishlistCookie(postId, postType);
                } else {
                    showNotification(postTypeText + '  is already in the wishlist', 'error');
                }
            } else {
                addToWishlistDb(postId, userId, postType);
            }
        });

        jQuery('body').on('click', '.mj-directory-listing__item .remove_from_wishlist', function (e) {
            e.preventDefault();
            var postId = jQuery(this).data('id');
            var userId = jQuery(this).data('login');
            var postType = jQuery(this).data('type');
            var isRemoved = false;

            if (jQuery(this).hasClass('mj-directory-listing__trash-icon')) {
                var wishlistPage = true;
            }

            if (userId === 0) {
                isRemoved = removeFromWishlistCookie(postId, postType);
            } else {
                isRemoved = removeFromWishlistDb(postId, userId, wishlistPage);
            }

            if (isRemoved) {
                location.reload(); // Refresh the page
            }
        });


        jQuery('body').on('click', '#mj-wishlist__clear-all-btn', function (e) {
            e.preventDefault();
            var confirmation = confirm('Are you sure you want to remove all venues from your wishlist?');
            if (confirmation) {
                var userId = jQuery(this).data('login');
                var postType = jQuery(this).data('type');
                if (userId === 0) {
                    clearAllFromWishlistCookie(postType);
                } else {
                    clearAllFromWishlistDb(userId, postType);
                }
            } else {
                // console.log('Removing cancelled');
            }
        });
    });


    function addToWishlistCookie(postId, postType) {
        var heartIcon = jQuery('.add_to_wishlist[data-id="' + postId + '"]');
        var cookieName = "";
        var postTypeText = "Venue";

        if (postType == "venue") {
            cookieName = 'wishlist_pending_venues';

        } else if (postType == "supplier") {
            cookieName = 'wishlist_pending_suppliers';
            postTypeText = "Supplier";
        }

        const wishlistStatusCookie = 'wishlistInitiated';

        var wishlistCookie = getCookie(cookieName);

        var wishlistArray = wishlistCookie ? JSON.parse(wishlistCookie) : [];
        wishlistArray.push(postId);
        setCookie(cookieName, JSON.stringify(wishlistArray), 7);
        toggleWishlistClass(heartIcon);

        // Check if the 'wishlistInitiated' cookie doesn't exist or its value is 'false'
        if (!getCookie(wishlistStatusCookie) || getCookie(wishlistStatusCookie) === 'false') {
            // Trigger the wishlist notification popup
            loadPopup('wishlist-notification');
            // Set the 'wishlistInitiated' cookie to 'true' with an expiration of 7 days
            setCookie(wishlistStatusCookie, 'true', 7);
        } else {
            showNotification(postTypeText + ' added to your Wishlist', 'info');
        }
    }

    function addToWishlistDb(postID, userID, postType) {
        var heartIcon = jQuery('.add_to_wishlist[data-id="' + postID + '"]');
        // Prepare the data to be sent to the server
        var requestData = {
            action: 'add_to_wishlist',
            post_id: postID,
            user_id: userID,
            post_type: postType,
        };

        // Make the AJAX request
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: requestData,
            cache: false,
            success: function (response) {
                if (response.success) {

                    if (!response.data.wishlistInitiated) {
                        loadPopup('wishlist-notification');
                    } else {
                        showNotification(response.data.message, 'success');
                    }
                    // Item added successfully
                    toggleWishlistClass(heartIcon);
                } else {
                    showNotification(response.data, 'error');
                }
            },
            error: function (xhr, status, error) {
                console.error('Error adding item to wishlist:', error);

                // Handle specific error cases if needed
                if (xhr.status === 400) {
                    showNotification('Invalid request. Please try again.', 'error');
                } else {
                    showNotification('An unexpected error occurred. Please try again later.', 'error');
                }
            }
        });
    }

    function removeFromWishlistCookie(postId, postType) {
        var heartIcon = jQuery('.remove_from_wishlist[data-id="' + postId + '"]');

        var cookieName = "";
        var postTypeText = "Venue";

        if (postType == "venue") {
            cookieName = 'wishlist_pending_venues';

        } else if (postType == "supplier") {
            cookieName = 'wishlist_pending_suppliers';
            postTypeText = "Supplier";
        }

        var wishlistCookie = getCookie(cookieName);

        if (wishlistCookie) {
            var wishlistArray = JSON.parse(wishlistCookie);
            // Remove the postId from the array
            wishlistArray = wishlistArray.filter(function (id) {
                return id !== postId;
            });

            // Update the cookie with the new array
            setCookie(cookieName, JSON.stringify(wishlistArray), 7);
            toggleWishlistClass(heartIcon, false);

            showNotification(postTypeText + ' removed from your Wishlist', 'info');
            return true; // Operation successful
        } else {
            showNotification('Wishlist is empty or item not found.', 'warning');
            return false; // Operation failed
        }
    }


    // function removeFromWishlistCookie(postId, wishlistPage) {
    //     var wishlistCookie = getCookie('wishlist_pending_posts');
    //     var wishlistArray = wishlistCookie ? JSON.parse(wishlistCookie) : [];

    //     // Remove the postId from the wishlistArray
    //     wishlistArray = wishlistArray.filter(function (item) {
    //         return item !== postId;
    //     });

    //     if (wishlistPage) {
    //         var confirmation = window.confirm("Are you sure you want to remove this item from your wishlist?");
    //         if (confirmation) {
    //             // Update the wishlistCookie
    //             setCookie('wishlist_pending_posts', JSON.stringify(wishlistArray), 7);

    //             var removedItem = '[data-post-id="' + postId + '"]';
    //             var elementToRemove = jQuery(removedItem);
    //             // Remove the element
    //             elementToRemove.remove();
    //         }
    //     } else {
    //         // Update the wishlistCookie
    //         setCookie('wishlist_pending_posts', JSON.stringify(wishlistArray), 7);

    //         var heartIcon = jQuery('.remove_from_wishlist[data-id="' + postId + '"]');
    //         toggleWishlistClass(heartIcon);
    //     }

    //     showNotification('Item removed from your wishlist.', 'error');
    // }

    function removeFromWishlistDb(postID, userID, wishlistPage) {
        // Prepare the data to be sent to the server
        var requestData = {
            action: 'remove_from_wishlist',
            post_id: postID,
            user_id: userID,
        };

        // Ask for confirmation if on wishlist page
        if (wishlistPage) {
            var confirmation = window.confirm("Are you sure you want to remove this item from your wishlist?");
            if (!confirmation) {
                return false; // Cancel the removal if the user declines
            }
        }

        // Make the AJAX request
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: requestData,
            success: function (response) {
                if (response.success) {
                    // Item removed successfully
                    if (wishlistPage) {
                        var removedItem = '[data-post-id="' + postID + '"]';
                        var elementToRemove = jQuery(removedItem);
                        // Remove the element
                        elementToRemove.remove();
                    } else {
                        var heartIcon = jQuery('.remove_from_wishlist[data-id="' + postID + '"]');
                        toggleWishlistClass(heartIcon);
                    }
                    showNotification(response.data, 'error');
                    return true; // Operation successful
                } else {
                    showNotification(response.data, 'error');
                    return false; // Operation failed
                }
            },
            error: function (xhr, status, error) {
                console.error('Error removing venue from wishlist:', error);

                // Handle specific error cases if needed
                if (xhr.status === 400) {
                    showNotification('Invalid request. Please try again.', 'error');
                } else {
                    showNotification('An unexpected error occurred. Please try again later.', 'error');
                }
                return false; // Operation failed due to an error
            }
        });
    }

    function clearAllFromWishlistCookie(postType) {
        var wishlistCookie = getCookie('wishlist_pending_posts');
        var wishlistArray = wishlistCookie ? JSON.parse(wishlistCookie) : [];

        if (wishlistArray.length > 0) {
            wishlistArray = [];
            setCookie('wishlist_pending_posts', JSON.stringify(wishlistArray), 7);
            jQuery('.mj-directory-listing.mj-wishlist__listing').empty();
            showNotification('All venues removed from your wishlist.', 'error');
            window.location.reload(true);
        } else {
            showNotification('Wishlist is already empty.', 'error');
        }
    }

    function clearAllFromWishlistDb(userID, postType) {
        // Prepare the data to be sent to the server
        var requestData = {
            action: 'remove_all_from_wishlist',
            user_id: userID,
            post_type: postType
        };

        // Make the AJAX request
        $.ajax({
            url: missjones_data.ajax_url,
            type: 'POST',
            data: requestData,
            success: function (response) {
                if (response.success) {
                    // Item removed successfully
                    jQuery('.mj-directory-listing.mj-wishlist__listing').empty();
                    showNotification(response.data, 'error');
                    window.location.reload(true);
                } else {
                    showNotification(response.data, 'error');
                }
            },
            error: function (xhr, status, error) {
                console.error('Error removing venue from wishlist:', error);

                // Handle specific error cases if needed
                if (xhr.status === 400) {
                    showNotification('Invalid request. Please try again.', 'error');
                } else {
                    showNotification('An unexpected error occurred. Please try again later.', 'error');
                }
            }
        });
    }

    function toggleWishlistClass(heartIcon) {
        if (heartIcon.hasClass('add_to_wishlist')) {
            heartIcon.removeClass('add_to_wishlist').addClass('remove_from_wishlist');
            if (heartIcon.hasClass('mj-single-venue__wishlist-btn')) {
                heartIcon.text("Remove from wishlist");
                heartIcon.addClass("added");
                heartIcon.find('span.icon img').attr('src', function (index, oldSrc) {
                    // Replace the old source with the new source
                    return oldSrc.replace('mj-wishlist-heart.svg', 'mj-wishlist-heart-fill.svg');
                });
            } else {
                heartIcon.find('img').attr('src', function (index, oldSrc) {
                    return oldSrc.replace('mj-wishlist-heart.svg', 'mj-wishlist-heart-fill.svg');
                });
            }
            heartIcon.find('.mj-tooltip').text('Remove from wishlist');
        } else if (heartIcon.hasClass('remove_from_wishlist')) {
            heartIcon.removeClass('remove_from_wishlist').addClass('add_to_wishlist');
            heartIcon.find('img').attr('src', function (index, oldSrc) {
                return oldSrc.replace('mj-wishlist-heart-fill.svg', 'mj-wishlist-heart.svg');
            });
            heartIcon.find('.mj-tooltip').text('Add to wishlist');
            if (heartIcon.hasClass('mj-single-venue__wishlist-btn')) {
                heartIcon.text("Add to wishlist");
                heartIcon.removeClass("added");
                heartIcon.find('span.icon img').attr('src', function (index, oldSrc) {
                    // Replace the old source with the new source
                    return oldSrc.replace('mj-wishlist-heart-fill.svg', 'mj-wishlist-heart.svg');
                });
            } else {
                heartIcon.find('img').attr('src', function (index, oldSrc) {
                    return oldSrc.replace('mj-wishlist-heart-fill.svg', 'mj-wishlist-heart.svg');
                });
            }
        }
    }

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + value + expires + '; path=/';
    }
});


document.addEventListener('DOMContentLoaded', function () {
    var selectAllButtons = document.querySelectorAll('.mj-wishlist__select-all-btn');
    var activeTypeElement = document.querySelector('#wishlist-type');
    var activeType = activeTypeElement ? activeTypeElement.value : null;
    var enquireButton = document.querySelector('.mj-btn.mj-wishlist__menu-btn.--black');
    var wishlistCheckboxes = document.querySelectorAll('.mj-wishlist__select input[type="checkbox"]');
    var selectedItemsInput = document.querySelector('#wishlist-selected-items-ids');

    // Check if required elements exist
    if (!selectAllButtons.length || !enquireButton || !wishlistCheckboxes.length || !selectedItemsInput || !activeType) {
        return; // Stop further execution if any key element is missing
    }

    // Event listener for each checkbox to update the selected items
    wishlistCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            updateSelectedItems();
            toggleEnquiryDisabledState();
        });
    });

    selectAllButtons.forEach(function (selectAllButton) {
        selectAllButton.addEventListener('click', function (e) {
            e.preventDefault();
            var isChecked = selectAllButton.innerHTML.trim() === 'Deselect all';
            var currentIds = selectedItemsInput.value ? selectedItemsInput.value.split(',') : [];
            var currentType = selectAllButton.getAttribute('data-type');

            wishlistCheckboxes.forEach(function (checkbox) {
                var dataId = checkbox.getAttribute('data-id');
                var dataType = checkbox.getAttribute('data-type'); // Get the data-type value

                // Check if the checkbox's data-type matches the activeType
                if (dataType === currentType) {
                    checkbox.checked = !isChecked;

                    if (!isChecked && !currentIds.includes(dataId)) {
                        currentIds.push(dataId);
                    }
                }
            });

            // Update the value of the input field with the selected IDs
            selectedItemsInput.value = isChecked ? "" : currentIds.join(',');

            selectAllButton.innerHTML = isChecked ? 'Select all' : 'Deselect all';

            // Update the text of the enquire button based on the "Select all" state
            var enquireTextButton = document.querySelector('.mj-wishlist__enquire-venues-btn'); // Adjust if you have multiple
            if (enquireTextButton) {
                enquireTextButton.textContent = isChecked ? 'Enquire selected venues' : 'Enquire all venues';
            }
            toggleEnquiryDisabledState();
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.mj-wishlist__tab');

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {

            updateSelectedItems();
            // Remove 'active' class from all tabs
            tabs.forEach(t => t.classList.remove('active'));

            // Add 'active' class to the clicked tab
            this.classList.add('active');
            let type = this.getAttribute('data-type');

            var selectAllButtons = document.querySelectorAll('.mj-wishlist__select-all-btn');

            selectAllButtons.forEach(function (button) {
                button.textContent = "Select all";
            });

            var enquireButtons = document.querySelectorAll('.mj-wishlist__enquire-btn');

            enquireButtons.forEach(function (button) {
                var dataType = button.getAttribute('data-type');

                if (dataType === 'venue') {
                    button.textContent = "Enquire selected venues";
                } else if (dataType === 'supplier') {
                    button.textContent = "Enquire selected suppliers";
                }
            });

            document.getElementById('wishlist-selected-items-ids').value = '';
            var wishlistCheckboxes = document.querySelectorAll('.mj-wishlist__select input[type="checkbox"]');

            wishlistCheckboxes.forEach(function (checkbox) {
                checkbox.checked = false;
            });

            updateWishlistTab(type);
            toggleEnquiryDisabledState();
        });
    });
});

function updateWishlistTab(type) {
    updateActiveClass('.mj-wishlist__menu-btns', type);
    updateActiveClass('.mj-wishlist__listing', type);
    updateActiveClass('.mj-wishlist__actions', type);
    updateActiveClass('.mj-wishlist__actions.--secondary', type);

    const wishListTypeInput = document.querySelector('#wishlist-type');
    if (wishListTypeInput) {
        wishListTypeInput.value = type;
    }
}

const updateActiveClass = (selector, type) => {
    document.querySelectorAll(selector).forEach(element => {
        element.classList.toggle('--active', element.dataset.type === type);
    });
};

function toggleEnquiryDisabledState() {
    // Get the input field for selected items
    const selectedItemsInput = document.querySelector('#wishlist-selected-items-ids');
    if (!selectedItemsInput) return; // Exit if input field is not found

    // Get the venue and supplier buttons
    const venueEnquireButton = document.querySelector('.mj-wishlist__enquire-venues-btn');
    const supplierEnquireButton = document.querySelector('.mj-wishlist__enquire-suppliers-btn');

    // Find the active tab
    const activeTab = document.querySelector('.mj-wishlist__tab.active'); // Fix: Use querySelector for a single active tab

    if (activeTab) {
        // Get the data-type value of the active tab
        const dataType = activeTab.getAttribute('data-type');

        if (dataType === 'venue' && venueEnquireButton) {
            // Toggle the --disabled class for venueEnquireButton
            if (selectedItemsInput.value.trim() === '') {
                venueEnquireButton.classList.add('--disabled');
            } else {
                venueEnquireButton.classList.remove('--disabled');
            }
        } else if (dataType === 'supplier' && supplierEnquireButton) {
            // Toggle the --disabled class for supplierEnquireButton
            if (selectedItemsInput.value.trim() === '') {
                supplierEnquireButton.classList.add('--disabled');
            } else {
                supplierEnquireButton.classList.remove('--disabled');
            }
        }
    }
}

// Function to update the value of #wishlist-selected-items-ids
function updateSelectedItems() {
    var activeTypeElement = document.querySelector('#wishlist-type');
    var activeType = activeTypeElement ? activeTypeElement.value : null;
    var wishlistCheckboxes = document.querySelectorAll('.mj-wishlist__select input[type="checkbox"]');
    var selectedItemsInput = document.querySelector('#wishlist-selected-items-ids');
    var currentIds = selectedItemsInput.value ? selectedItemsInput.value.split(',') : [];

    wishlistCheckboxes.forEach(function (checkbox) {
        var dataId = checkbox.getAttribute('data-id');
        var dataType = checkbox.getAttribute('data-type'); // Get data-type attribute

        // Skip checkbox if activeType does not match data-type
        if (activeType !== dataType) {
            return; // Skip to the next iteration
        }

        if (checkbox.checked) {
            // Add ID if it's not already in the list
            if (!currentIds.includes(dataId)) {
                currentIds.push(dataId);
            }
        } else {
            // Remove ID if it's unchecked and exists in the list
            currentIds = currentIds.filter(function (id) {
                return id !== dataId;
            });
        }
    });

    // Update the value of the input field with the selected IDs
    selectedItemsInput.value = currentIds.join(',');
}